import { CartAddEvent } from '@theme/events';
// A visit spans navigation, but not a new browser session. Count openings, not cart rerenders.
const key = 'laffrey-pair-openings-v1';
let openings = 0;
try { openings = Number(sessionStorage.getItem(key)) || 0; } catch {}
document.documentElement.toggleAttribute('data-laf-pairs-hidden', openings >= 2);
const observed = new WeakSet();
const attach = () => {
  for (const dialog of document.querySelectorAll('cart-drawer-component dialog')) {
    if (observed.has(dialog)) continue;
    observed.add(dialog);
    let wasOpen = dialog.open;
    new MutationObserver(() => {
      if (dialog.open && !wasOpen) {
        openings += 1;
        try { sessionStorage.setItem(key, String(openings)); } catch {}
        document.documentElement.toggleAttribute('data-laf-pairs-hidden', openings > 2);
      }
      wasOpen = dialog.open;
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }
};
attach();
new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.laf-pair-form')) return;
  event.preventDefault();
  const button = form.querySelector('button');
  if (button.disabled) return;
  button.disabled = true;
  const error = form.querySelector('.laf-pair-error');
  error.textContent = '';
  const data = new FormData(form);
  const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))];
  data.set('sections', sections.join(','));
  data.set('sections_url', location.pathname);
  try {
    const response = await fetch(form.action + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || form.dataset.error);
    document.dispatchEvent(new CartAddEvent({}, String(data.get('id')), { source: 'product-form-component', itemCount: 1, productId: form.dataset.productId, sections: result.sections }));
  } catch (cause) { error.textContent = cause.message || form.dataset.error; }
  finally { button.disabled = false; }
});

// Prices are rendered in the visitor's market currency by Liquid.
document.addEventListener('change', event => {
 const input = event.target;
 if (!(input instanceof HTMLElement) || !input.matches('.laf-pair-form [name="id"]')) return;
 const option = input instanceof HTMLSelectElement ? input.selectedOptions[0] : input;
 const price = input.closest('form').querySelector('[data-laf-price]');
 if (price && option?.dataset.price) price.textContent = option.dataset.price;
});
